export default __webpack_public_path__ + "static/media/GreaterThanIcon.f27218d2.svg";